"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheNexusAdvantage() {
  const headlineWords = [{
    text: "Architecting",
    italic: false
  }, {
    text: "your",
    italic: true
  }, {
    text: "next",
    italic: true
  }, {
    text: "professional",
    italic: false
  }, {
    text: "evolution",
    italic: false
  }, {
    text: "today",
    italic: false
  }];
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: buttonsRef,
    isVisible: buttonsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: scrollRef,
    isVisible: scrollVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3781" id="the-nexus-advantage" className="relative w-full overflow-hidden bg-background text-foreground">
      <div className="relative mx-auto max-w-[1440px] px-6 pt-12 pb-24 md:px-12 md:pt-20 md:pb-32 lg:pt-20 lg:pb-40">
        {}
        <div ref={scrollRef} className="absolute left-4 bottom-12 hidden lg:flex items-center" style={{
        opacity: scrollVisible ? 1 : 0,
        transform: scrollVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 800ms ease-out 600ms, transform 800ms ease-out 600ms"
      }}>
          <div className="flex items-center gap-3">
            <div className="h-24 w-px bg-foreground/30" />
            <span className="font-mono uppercase text-foreground/60" style={{
            fontSize: "11px",
            letterSpacing: "0.2em",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)"
          }}>
              Search &#9702; Connect &#9702; Evolve
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {}
          <div className="lg:col-span-5 lg:col-start-1 lg:pt-20">
            <div ref={imageRef} className="relative" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "scale(1)" : "scale(0.96)",
            transition: "opacity 1200ms ease-out, transform 1200ms ease-out"
          }}>
              {}
              <div className="absolute -inset-8 -z-10 opacity-70" style={{
              background: "radial-gradient(closest-side, hsla(38, 48%, 56%, 0.35), transparent 80%)"
            }} />
              <div className="overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/corporate_recruitment_leadership.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/corporate_recruitment_leadership.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/corporate_recruitment_leadership.webp-wvc-sizes" alt="Professional corporate leadership in a high-end office environment" loading="lazy" decoding="async" className="block h-auto w-full object-cover" style={{
                aspectRatio: "4 / 5"
              }} />
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7">
            {}
            <div ref={eyebrowRef} style={{
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms ease-out, transform 700ms ease-out"
          }}>
              <span className="font-mono uppercase text-foreground/70" style={{
              fontSize: "11px",
              letterSpacing: "0.25em"
            }}>
                NEXUS &#9702; TALENT PARTNERS
              </span>
            </div>

            {}
            <h1 ref={headlineRef} className="font-default mt-6 text-foreground" style={{
            fontSize: "clamp(2.75rem, 8vw, 8rem)",
            lineHeight: "0.95",
            letterSpacing: "-0.03em",
            fontWeight: 700
          }}>
              <span className="block">
                {headlineWords.slice(0, 3).map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom">
                    <span className="inline-block" style={{
                  opacity: headlineVisible ? 1 : 0,
                  transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
                  transition: `opacity 800ms ease-out ${i * 80}ms, transform 800ms ease-out ${i * 80}ms`,
                  color: word.italic ? "var(--primary)" : "var(--foreground)",
                  fontStyle: word.italic ? "italic" : "normal",
                  marginRight: "0.25em"
                }}>
                      {word.text}
                    </span>
                  </span>)}
              </span>
              <span className="block">
                {headlineWords.slice(3).map((word, i) => {
                const idx = i + 3;
                return <span key={idx} data-index={idx} className="inline-block overflow-hidden align-bottom">
                      <span className="inline-block" style={{
                    opacity: headlineVisible ? 1 : 0,
                    transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
                    transition: `opacity 800ms ease-out ${idx * 80}ms, transform 800ms ease-out ${idx * 80}ms`,
                    color: word.italic ? "var(--primary)" : "var(--foreground)",
                    fontStyle: word.italic ? "italic" : "normal",
                    marginRight: "0.25em"
                  }}>
                        {word.text}
                      </span>
                    </span>;
              })}
              </span>
            </h1>

            {}
            <div className="mt-10 lg:pl-[8.333%] lg:pr-[8.333%]">
              
            </div>

            {}
            <div ref={buttonsRef} className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center lg:pl-[8.333%]" style={{
            opacity: buttonsVisible ? 1 : 0,
            transform: buttonsVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 900ms ease-out 600ms, transform 900ms ease-out 600ms"
          }}>
              <Button asChild size="lg" className="font-default h-14 rounded-lg bg-primary px-8 text-base text-primary-foreground hover:bg-primary/90">
                <Link to="/EmployersPage">Find Top Talent</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="font-default h-14 rounded-lg border-secondary bg-transparent px-8 text-base text-secondary hover:bg-secondary hover:text-secondary-foreground">
                <Link to="/JobBoardPage">Explore Job Openings</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}